import { BareActionContext } from 'vuex-typex'
import { CommentState } from '../state'
import { RootState } from '../..'
import fetchLikes from './fetch-likes'
import { IComment } from '../../../model/comment'
import fetchCreator from './fetch-creator'
import fetchStatements from '@/store/comment/actions/fetch-statements';

export default async function setMeta(context: BareActionContext<CommentState, RootState>, comment: IComment)
{
    fetchCreator(context, comment)
    fetchLikes(context, comment)
    fetchStatements(context, comment)
    // fetchComments(context, comment)

    return
}
